import { Link } from 'react-router-dom'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

import Logo from '@/components/Logo'
import AuthBackgroundShape from '@/components/AuthBackgroundShape'
import LoginForm from '@/components/shadcn-studio/blocks/login-page-01/login-form'

const Login = () => {
  return (
    <div className='relative flex h-auto min-h-screen items-center justify-center overflow-x-hidden px-4 py-10 sm:px-6 lg:px-8'>
      <div className='absolute'>
        <AuthBackgroundShape />
      </div>

      <Card className='z-1 w-full border-none shadow-md sm:max-w-lg'>
        <CardHeader className='gap-3 items-center justify-center'>
          <Logo className='gap-3 mx-auto' showText={false} />
          <div>
            <CardTitle className='mb-1.5 text-2xl'>Sign in to Fenra</CardTitle>
          </div>
        </CardHeader>

        <CardContent>
          {/* Login Form */}
          <div className='space-y-4'>
            <LoginForm />

            <p className='text-muted-foreground text-center'>
              New to Fenra?{' '}
              <Link to='/auth/register' className='text-card-foreground hover:underline'>
                Create an account
              </Link>
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

export default Login
